<template>
    <div class="messageWrap body" :class="`type-${type} ${v2 ? 'v2' : 'v1 font-4'}`" v-if="message">
        <IconBase v-if="v1" width="15" height="15"
                  :iconName="iconName"
                  class="message-icon"
                  display="inline-flex"></IconBase>
        <slot>{{message}}</slot>
        <span v-if="dismissButton" @click="$emit('acknowledged')" class="right button">
            <IconBase iconName="closeV2Icon" :iconColor="iconColors[type]" width="8" height="8"></IconBase>
        </span>
    </div>
</template>

<script>
import consts from 'services/metaData/consts';
import { capitalize } from 'services/utils/strings';
import IconBase from '../IconBase.vue';

export default {
    name: 'SystemMessage',
    components: { IconBase },
    props: {
        message: {
            type: String,
            required: true
        },
        icon: {
            type: String
        },
        dismissButton: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: 'error',
            validator: (val) => ['error', 'success', 'info', 'warning'].includes(val)
        },
        v1: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            iconColors: {
                error: consts.COLORS.NEGATIVE_700
            }
        };
    },
    computed: {
        v2() {
            return !this.v1;
        },
        iconName() {
            return this.icon || (this.v1 && `notification${capitalize(this.type)}Icon`);
        }
    }
};
</script>

<style scoped lang="scss">
    .v2 {
        @import "~styles/styleGuide.V2";

        &.messageWrap.type-error {
            background-color: $negative-100;
            color: $negative-700;
            padding: 10px;
            border-left: 4px solid $negative-500;
            border-radius: 4px;
            margin-top: 8px;
            margin-left: 15px;
            margin-right: 15px;
        }

        .button {
            cursor: pointer;
        }
    }

    .v1 {
        @import "~styles/styleGuide";

        &.messageWrap {
            padding: 10px 15px;
            display: flex;
            align-items: center;

            &.type-error {
                color: $negative;
                background-color: $negative-100;
                border-bottom: solid 1px $negative-200;
            }

            &.type-success {
                color: $positive;
                background-color: $positive-100;
                border-bottom: solid 1px $positive;
            }

            &.type-warning {
                color: #224574;
                background-color: $primary-100;
                border-bottom: solid 1px $light;
            }
        }

        .message-icon {
            margin-right: 10px;
        }

        .button {
            cursor: pointer;
            margin-left: auto;
        }
    }
</style>
